import { SurveyResponse } from "./SurveyResponse";

export class SurveyResponseWrapper {
    public constructor(public surveyResponse: SurveyResponse) {
    }
 }
